import InstagramMessage from './InstagramMessage';
export default InstagramMessage;
